/* eslint-disable @typescript-eslint/no-explicit-any */
type RawQueryParams = Record<string, any>;

export const sanitizeRedirectUriParams = (
  queryParams: RawQueryParams,
): Record<string, string> => {
  const sanitized: Record<string, string> = {};
  const excludedKeys = new Set(['code', 'state']);

  Object.entries(queryParams).forEach(([key, value]) => {
    if (excludedKeys.has(key)) return;
    if (value === undefined || value === null || value === '') return;

    const strKey = String(key);
    const strValue = String(value);

    sanitized[strKey] = encodeURIComponent(strValue);
  });

  return sanitized;
};
